// extracted by mini-css-extract-plugin
export default {"container":"RootPage_container__8sQkE"};